import { useStores } from "stores";
import { observer } from "mobx-react-lite";
import { CommonTable } from "components";
import { getColumns } from "./getColumns";
import { useNavigate } from "react-router-dom";
import { CustomButton } from "ui";
import { routes } from "constants/routes";
import { Col, Flex, Typography } from "antd";

export const ContractsPage = observer(() => {
  const { contracts, user } = useStores();
  const navigate = useNavigate();

  const { isCustomer, isJuniorOperator, isSeniorOperator, isRiskManager } = user.roles;
  const canSearchOnGrid = isCustomer || isJuniorOperator || isSeniorOperator || isRiskManager;
  const showCreateContractButton = isCustomer;

  return (
    <Flex vertical gap="large">
      <Flex justify="space-between" align="center">
        <Typography.Title className="margin-none">Договоры</Typography.Title>
        {showCreateContractButton && (
          <CustomButton
            onClick={() => {
              navigate(`/${routes.contracts}/create`);
            }}
          >
            Новый договор
          </CustomButton>
        )}
      </Flex>
      <Flex vertical gap="large">
        <CommonTable
          id="contracts-table"
          store={contracts}
          columns={getColumns(user, contracts)}
          onRow={(record) => ({
            onClick: () => {
              navigate(record.id);
            },
            className: "cursor-pointer",
          })}
          updateWithInterval
          whiteBox
          widgets={{
            search: canSearchOnGrid,
            date: true,
          }}
        />
      </Flex>
    </Flex>
  );
});
